import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  DATE_FORMAT,
  FieldWrapperVerticalV2,
  useUserAccess,
} from '@ui-framework/index';
import DispatchMap from './DispatchMap';
import DispatchStatus from '../../../../DispatchStatus';
import UpdateAppointmentDate from '../../../../Dialogs/UpdateAppointmentDateDialog';

function DispatchDetails({ dispatch, serviceJob, assignedServiceProvider }) {
  const [rescheduleDialog, setRescheduleDialog] = useState(false);
  const userAccess = useUserAccess();
  const { serviceProviderLocation } = serviceJob;

  const getAppointmentDate = () => {
    if (serviceJob?.appointmentDate) {
      return (
        <Box>
          {serviceJob?.appointmentDate && (
            <Box>
              <Typography
                color="tertiary.main"
                fontWeight="bold"
                variant="body2">
                {serviceJob?.appointmentDate}
              </Typography>
            </Box>
          )}
          <Box>
            {serviceJob?.appointmentArrivalStartTime && (
              <Typography
                color="tertiary.main"
                variant="body2"
                component="span">
                (After{' '}
                {dayjs(
                  serviceJob?.appointmentArrivalStartTime,
                  'HH:mm',
                )?.format('h:mm A')}
                )
              </Typography>
            )}
          </Box>
          <Box>
            {serviceJob?.appointmentArrivalEndTime && (
              <Typography
                color="tertiary.main"
                variant="body2"
                component="span">
                (Before{' '}
                {dayjs(serviceJob?.appointmentArrivalEndTime, 'HH:mm')?.format(
                  'h:mm A',
                )}
                )
              </Typography>
            )}
          </Box>
        </Box>
      );
    }
    return <Box>&ndash; </Box>;
  };

  const getServiceProviderLocation = () => {
    if (serviceProviderLocation?.locationName) {
      return <Box>{serviceProviderLocation?.locationName} </Box>;
    }
    return <Box>&ndash; </Box>;
  };

  const detailsField = {
    name: 'dispatch_details',
    label: {
      localeId: 'DISPATCH_DETAILS',
      defaultMessage: 'Dispatch Details',
    },
    control: 'subsection',
  };

  const fields = [
    ...(userAccess.isSA() || userAccess.isAdmin()
      ? [
          {
            name: 'service_provider',
            label: {
              localeId: 'SERVICE_PROVIDER',
              defaultMessage: 'Service Provider',
            },
            control: 'text',
            value: assignedServiceProvider?.name || 'Not Assigned',
          },
        ]
      : []),
    {
      name: 'service_provider_location',
      label: {
        localeId: 'SERVICE_PROVIDER_LOCATION',
        defaultMessage: 'Location',
      },
      control: 'text',
      value: getServiceProviderLocation(),
    },
    {
      name: 'dispatch_number',
      label: {
        localeId: 'DISPATCH_NUMBER',
        defaultMessage: 'Dispatch Number',
      },
      control: 'text',
      value: dispatch?.dispatchNumber,
    },

    {
      name: 'appointment_window',
      label: {
        localeId: 'APPOINTMENT_WINDOW',
        defaultMessage: 'Appointment Window',
      },
      control: 'AppointmentWindow',
      value: getAppointmentDate(),
    },
    ...(userAccess.isSA() || userAccess.isAdmin()
      ? [
          {
            name: 'dispatch_details',
            label: {
              localeId: 'DISPATCH_STATUS',
              defaultMessage: 'Dispatch Status',
            },
            control: 'DispatchStatus',
            value: dispatch?.status || '',
          },
        ]
      : []),
    {
      name: 'dispatch_created_date',
      label: {
        localeId: 'DISPATCH_CREATED_DATE_HEADING',
        defaultMessage: 'Created Date',
      },
      control: 'text',
      value: dispatch.createdDateTime
        ? dayjs(dispatch.createdDateTime).format(DATE_FORMAT.LONG_DATE)
        : '',
    },
    {
      name: 'dispatch_lastModified_date',
      label: {
        localeId: 'DISPATCH_LAST_MODIFIED_DATE_HEADING',
        defaultMessage: 'Last Modified Date',
      },
      control: 'text',
      value: dispatch.lastModifiedDateTime
        ? dayjs(dispatch.lastModifiedDateTime).format(DATE_FORMAT.LONG_DATE)
        : '',
    },
  ];

  const Mapfields = {
    name: 'dispatch_map',
    label: {
      localeId: 'DISPATCH_STATUS',
      defaultMessage: 'Dispatch Status',
    },
    value: serviceJob.id,
  };

  return (
    <FieldWrapperVerticalV2
      key={detailsField?.name}
      field={detailsField}
      errors={[]}>
      <UpdateAppointmentDate
        open={rescheduleDialog}
        onClose={() => {
          setRescheduleDialog(false);
        }}
        jobInfo={serviceJob}
      />
      {!dispatch?.id ? (
        <Grid2 container sx={{ m: 1 }}>
          <Typography>No dispatch information to display</Typography>
        </Grid2>
      ) : (
        <Grid2 container>
          <Grid2 xs={11} columnSpacing={10} container>
            {fields.map(f => {
              let control = null;
              switch (f.control) {
                case 'DispatchMap':
                  control = (
                    <Box textAlign="right">
                      <DispatchMap value={f.value} key={f.name} />
                    </Box>
                  );
                  break;
                case 'DispatchStatus':
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      <DispatchStatus value={f.value} key={f.name} />
                    </FieldWrapperVerticalV2>
                  );
                  break;
                case 'AppointmentWindow':
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      {f.value}
                    </FieldWrapperVerticalV2>
                  );
                  break;
                default:
                  control = (
                    <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                      <Box>
                        <Typography
                          color="tertiary.main"
                          fontWeight="bold"
                          variant="body2">
                          {f.value}
                        </Typography>
                      </Box>
                    </FieldWrapperVerticalV2>
                  );
              }
              return (
                <Grid2 xs={12 / fields.length} key={f.name}>
                  {control}
                </Grid2>
              );
            })}
          </Grid2>
          <Grid2 xs={1} key={Mapfields.name}>
            <Box textAlign="right">
              <DispatchMap value={Mapfields.value} key={Mapfields.name} />
            </Box>
          </Grid2>
        </Grid2>
      )}
    </FieldWrapperVerticalV2>
  );
}

export default DispatchDetails;
